var _style, _g, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _path4, _defs5, _path5, _defs6, _path6, _defs7, _path7, _defs8, _path8, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOatBran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#CC8C60;}\n\t.st2{clip-path:url(#SVGID_4_);fill:#CC8C60;}\n\t.st3{clip-path:url(#XMLID_2_);fill:#CC8C60;}\n\t.st4{clip-path:url(#XMLID_7_);fill:#CC8C60;}\n\t.st5{clip-path:url(#XMLID_8_);fill:#CC8C60;}\n\t.st6{clip-path:url(#SVGID_6_);fill:#CC8C60;}\n\t.st7{clip-path:url(#XMLID_9_);fill:#CC8C60;}\n\t.st8{clip-path:url(#SVGID_8_);fill:#CC8C60;}\n\t.st9{fill:#F5CDA6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M88.03,119.9c-0.49-1.3-1.24-2.52-2.44-2.77c-2.56-0.54-4.82-1.76-7.32-0.32 c-3.55,2.05-6.66,4.93-8.77,8.47c-2.22,3.72-3.97,9.02-2.21,13.25c1.26,3.03,4.29,5.09,6.98,5.83c3.6,0.99,8.57-1.01,11.14-3.56 c2.6-2.59,3.92-7.05,4.19-10.62c0.19-2.6-0.19-5.23-0.82-7.75C88.6,121.75,88.38,120.8,88.03,119.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.34,114.58c0,0-4.52,6.18-4.92,8.12s1.89,0.74,3.32-0.34c1.43-1.09,2.52-0.57,0.11,4 c-2.4,4.58-4.29,4-6.18,9.27c-1.89,5.26-5.26,7.78-5.26,7.78s1.6,2.75,2.06,2.4c0.46-0.34,3.72-8.35,4.92-10.75 c1.2-2.4,3.72-5.55,5.83-7.89c2.12-2.35,2.57-6.06,1.6-6.75c-0.97-0.69-3.66,0.34-3.66,0.34l3.2-5.49L83.34,114.58z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M86.74,54.38c-1.38-0.09-2.81,0.09-3.53,1.08c-1.55,2.11-3.6,3.67-3.31,6.53c0.4,4.08,1.74,8.1,4.09,11.48 c2.47,3.56,6.58,7.34,11.15,7.49c3.28,0.11,6.41-1.8,8.19-3.95c2.39-2.86,2.62-8.22,1.35-11.62c-1.28-3.44-4.8-6.48-7.94-8.2 c-2.29-1.25-4.84-1.99-7.4-2.45C88.67,54.63,87.72,54.44,86.74,54.38z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.97,56.46c0,0,3.76,6.67,5.37,7.83c1.61,1.17,1.46-1.41,1.06-3.16c-0.4-1.75,0.52-2.53,3.69,1.55 c3.18,4.08,1.87,5.56,5.89,9.45c4.01,3.89,4.91,8,4.91,8s3.16-0.32,3.04-0.88c-0.12-0.56-6.07-6.83-7.76-8.92 c-1.69-2.09-3.52-5.68-4.78-8.57s-4.46-4.85-5.49-4.25c-1.03,0.6-1.2,3.48-1.2,3.48l-3.68-5.18L79.97,56.46z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000182493193141822395380000017015822026367089300_",
    d: "M130.58,112.51c-0.03-2.48-1.15-5.17-3.57-5.95 c-1.43-0.46-10.18-2.46-14.99-0.69c-2.52,0.93-4.93,2.2-7.08,3.8c-2.79,2.07-6.22,3.84-7.79,7.07c-0.77,1.58-1.67,3.36-1.19,5.15 c1.07,4.05,5.23,6.31,8.97,7.32c5.02,1.35,10.47-1.18,14.85-3.39c4.58-2.31,8.77-5.89,10.45-10.92 C130.47,114.18,130.59,113.36,130.58,112.51z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000182493193141822395380000017015822026367089300_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000182493193141822395380000017015822026367089300_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.24,123.03c0,0,3.32,0.06,6.98-1.72c3.66-1.77,9.38-1.94,14.99-4.35s8.98-3.89,10.52-6.18 c1.54-2.29,1.83-4.23,1.83-4.23s2.12,4.29,2.29,4.58c0.17,0.29,0.34,2.97,0.34,2.97s-0.51-2.63-4.35-0.8 c-3.83,1.83-13.33,6.12-17.96,7.66c-4.63,1.54-7.95,1.49-9.84,3.66c-1.89,2.17-2.29,3.55-2.29,3.55s-1.94-1.6-2.75-2.29 C94.21,125.2,95.24,123.03,95.24,123.03z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000116924061022452312860000014814331131405705350_",
    d: "M60.08,82.87c-2.43,0.51-4.85,2.13-5.14,4.66 c-0.17,1.49-0.44,10.46,2.23,14.83c1.4,2.29,3.11,4.41,5.1,6.21c2.57,2.33,4.97,5.36,8.44,6.27c1.7,0.45,3.62,0.99,5.29,0.17 c3.76-1.84,5.17-6.36,5.44-10.22c0.35-5.18-3.19-10.04-6.21-13.91c-3.15-4.05-7.48-7.46-12.74-8.13 C61.74,82.65,60.91,82.7,60.08,82.87z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000116924061022452312860000014814331131405705350_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000116924061022452312860000014814331131405705350_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.26,115.49c0,0-0.59-3.27-3.04-6.51s-3.73-8.82-7.17-13.86c-3.44-5.03-5.56-8.05-8.1-9.13 c-2.54-1.07-4.51-0.97-4.51-0.97s3.8-2.91,4.05-3.13c0.25-0.22,2.85-0.91,2.85-0.91s-2.48,1.02,0.06,4.42 c2.54,3.4,8.59,11.89,11,16.13s3,7.51,5.5,8.94s3.92,1.56,3.92,1.56s-1.19,2.22-1.71,3.14C79.59,116.08,77.26,115.49,77.26,115.49z "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000108299293791352019940000002020734253311307434_",
    d: "M99.71,144.43c-0.96,2.29-1,5.2,0.91,6.88 c1.13,0.99,8.37,6.3,13.48,6.58c2.69,0.15,5.39-0.06,8.01-0.67c3.38-0.79,7.23-1.05,9.95-3.39c1.33-1.15,2.87-2.42,3.14-4.25 c0.62-4.14-2.3-7.87-5.33-10.28c-4.07-3.23-10.08-3.07-14.98-2.78c-5.12,0.3-10.39,1.92-13.92,5.87 C100.47,142.93,100.03,143.64,99.71,144.43z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000108299293791352019940000002020734253311307434_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000108299293791352019940000002020734253311307434_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.32,148.8c0,0-3.02-1.37-7.09-1.2c-4.06,0.17-9.38-1.94-15.48-1.96c-6.1-0.02-9.79,0-12.11,1.49 c-2.33,1.49-3.36,3.16-3.36,3.16s-0.24-4.78-0.28-5.11c-0.04-0.33,0.87-2.87,0.87-2.87s-0.57,2.62,3.67,2.46 c4.24-0.16,14.66-0.32,19.53,0.1c4.87,0.42,7.89,1.79,10.48,0.55s3.51-2.35,3.51-2.35s1.15,2.24,1.61,3.19 C138.12,147.22,136.32,148.8,136.32,148.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M143.16,127.11c0.89,1.07,1.99,1.98,3.21,1.83c2.6-0.32,5.13,0.1,7.03-2.07c2.7-3.09,4.71-6.82,5.56-10.85 c0.9-4.24,0.84-9.82-2.19-13.25c-2.17-2.46-5.71-3.43-8.49-3.26c-3.72,0.22-7.79,3.73-9.39,6.98c-1.62,3.29-1.43,7.94-0.53,11.4 c0.66,2.53,1.87,4.89,3.29,7.06C142.03,125.55,142.54,126.37,143.16,127.11z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M149.32,130.63c0,0,2.28-7.31,2.03-9.28c-0.25-1.97-2.03-0.09-3.03,1.4s-2.2,1.36-1.4-3.75 c0.79-5.11,2.76-5.18,2.85-10.77c0.08-5.59,2.46-9.06,2.46-9.06s-2.4-2.08-2.73-1.61c-0.32,0.47-0.82,9.1-1.17,11.77 c-0.36,2.66-1.72,6.45-2.97,9.36c-1.24,2.9-0.47,6.57,0.67,6.9c1.14,0.33,3.35-1.51,3.35-1.51l-1.25,6.23L149.32,130.63z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000152234964766425194270000007559135932100545179_",
    d: "M160.89,90.94c1.53-1.95,2.34-4.76,0.94-6.88 c-0.83-1.25-6.41-8.29-11.26-9.91c-2.55-0.85-5.22-1.37-7.9-1.47c-3.47-0.13-7.25-0.9-10.5,0.65c-1.59,0.76-3.4,1.57-4.15,3.27 c-1.7,3.83,0.14,8.19,2.43,11.32c3.07,4.19,8.91,5.62,13.71,6.64c5.02,1.06,10.53,0.89,14.98-1.99 C159.76,92.18,160.37,91.61,160.89,90.94z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000152234964766425194270000007559135932100545179_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000152234964766425194270000007559135932100545179_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126.74,77.06c0,0,2.55,2.12,6.52,3.02c3.97,0.91,8.54,4.35,14.41,5.98c5.88,1.63,9.44,2.58,12.08,1.76 c2.64-0.82,4.08-2.16,4.08-2.16s-1.03,4.67-1.08,5c-0.04,0.33-1.59,2.54-1.59,2.54s1.24-2.38-2.89-3.34 c-4.13-0.97-14.23-3.56-18.81-5.25c-4.58-1.69-7.13-3.81-9.97-3.3c-2.83,0.52-4,1.34-4,1.34s-0.52-2.47-0.71-3.5 C124.58,78.11,126.74,77.06,126.74,77.06z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M123.69,87.87c0.48-1.3,0.73-2.71-0.01-3.7c-1.57-2.09-2.47-4.51-5.29-5.07c-4.02-0.8-8.26-0.69-12.17,0.58 c-4.12,1.33-8.93,4.16-10.4,8.5c-1.05,3.11-0.13,6.66,1.4,8.99c2.05,3.12,7.11,4.9,10.72,4.67c3.67-0.23,7.6-2.71,10.15-5.22 c1.86-1.83,3.31-4.05,4.49-6.37C122.89,89.63,123.35,88.78,123.69,87.87z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#F5CDA6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M123.67,80.78c0,0-7.47,1.66-9.05,2.86c-1.58,1.2,0.93,1.8,2.72,1.93c1.79,0.13,2.27,1.23-2.55,3.09 c-4.82,1.86-5.87,0.18-10.75,2.89c-4.89,2.71-9.09,2.38-9.09,2.38s-0.61,3.12-0.04,3.16s8.3-3.83,10.79-4.84s6.45-1.72,9.59-2.09 s5.93-2.86,5.65-4.02c-0.28-1.16-2.98-2.16-2.98-2.16l6.03-2.02L123.67,80.78z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 86.73,
    cy: 91.69,
    r: 4.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 132.31,
    cy: 100.85,
    r: 4.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOatBran);
export default __webpack_public_path__ + "static/media/Oat_bran.4dba4a2811c544dc5f55f6660a24d628.svg";
export { ForwardRef as ReactComponent };